import React from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import useNavigation, { JourneyStep } from 'src/lib/hooks/useNavigation'
import { Header } from './Header'
import { ExploreMore } from './ExploreMore'
import { DynamicNavigation, NavigationSectionType } from './DynamicNavigation'
import { ShoppingBagOpen, ShoppingCart, Ticket } from '@phosphor-icons/react'
import { cartSections, checkoutSections, pdpSections, shopPassSections } from '../../nav-items'
import { PDP_NAV_ICON_URL } from 'src/lib/utils/constants'

interface NavigationWrapperProps {
  title: string
  icon: JSX.Element
  sections: NavigationSectionType[]
  journeyStep: JourneyStep
  exploreText: string
}

export const NavigationWrapper: React.FC<NavigationWrapperProps> = ({
  title,
  icon,
  sections,
  journeyStep,
  exploreText
}) => {
  const {
    getters: { journeyStep: currentJourneyStep }
  } = useNavigation()

  return (
    <div className='w-full'>
      <Header title={title} icon={icon} currentStep={currentJourneyStep} />

      <DynamicNavigation sections={sections} type={journeyStep} />

      <ExploreMore text={exploreText} id={`${journeyStep?.toLowerCase()}-explore-more`} />
    </div>
  )
}

interface JourneyNavigationComponentProps {
  stepId: JourneyStep
}

export const JourneyNavigationComponent: React.FC<JourneyNavigationComponentProps> = ({ stepId }) => {
  const { t } = useLocale()

  switch (stepId) {
    case JourneyStep.CHECKOUT:
      return (
        <NavigationWrapper
          title={t('navigation.checkout')}
          icon={<ShoppingCart size={20} weight='fill' className='text-emerald-500' />}
          sections={checkoutSections}
          journeyStep={JourneyStep.CHECKOUT}
          exploreText={t('navigation.add_more_control_on_checkout')}
        />
      )
    case JourneyStep.CART:
      return (
        <NavigationWrapper
          title={t('navigation.cart')}
          icon={<ShoppingBagOpen size={20} weight='fill' className='text-sky-500' />}
          sections={cartSections}
          journeyStep={JourneyStep.CART}
          exploreText={t('navigation.add_more_control_on_cart')}
        />
      )
    case JourneyStep.PDP:
      return (
        <NavigationWrapper
          title={t('navigation.pdp')}
          icon={<img src={PDP_NAV_ICON_URL} alt='Flo PDP' className='w-6 h-6 rounded-md' />}
          sections={pdpSections}
          journeyStep={JourneyStep.PDP}
          exploreText={t('navigation.add_more_control_on_pdp')}
        />
      )
    case JourneyStep.SHOP_PASS:
      return (
        <NavigationWrapper
          title={t('navigation.shop_pass')}
          icon={<Ticket size={20} weight='fill' className='text-violet-600' />}
          sections={shopPassSections}
          journeyStep={JourneyStep.SHOP_PASS}
          exploreText={t('navigation.add_more_control_on_shop_pass')}
        />
      )
    default:
      return null
  }
}
